// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvv77o{padding-left:var(--ds-space-025,2px)}\n._1bsbxy5q{width:var(--ds-space-400,2pc)}\n._4t3ixy5q{height:var(--ds-space-400,2pc)}\n._5ral1f51{object-fit:contain}\n._ca0qv77o{padding-top:var(--ds-space-025,2px)}\n._n3tdv77o{padding-bottom:var(--ds-space-025,2px)}\n._u5f3v77o{padding-right:var(--ds-space-025,2px)}\n._vchhusvi{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
